import { FormTest } from 'features/form-test';

export const Test = () => {
  return (
    <div className="container">
      <FormTest />
    </div>
  );
};
